import { render, staticRenderFns } from "./CiSelectionBox.vue?vue&type=template&id=85a43f7a&scoped=true"
import script from "./CiSelectionBox.vue?vue&type=script&lang=js"
export * from "./CiSelectionBox.vue?vue&type=script&lang=js"
import style0 from "./CiSelectionBox.vue?vue&type=style&index=0&id=85a43f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a43f7a",
  null
  
)

export default component.exports